
import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";
import AgentForm from "@/components/agent/AgentForm";
import MainLayout from "@/components/layout/MainLayout";

const AgentEdit = () => {
  const [agent, setAgent] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(true);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { toast } = useToast();

  useEffect(() => {
    const fetchAgent = async () => {
      if (!id) return;

      try {
        const { data, error } = await supabase
          .from("agents")
          .select("*")
          .eq("id", id)
          .single();

        if (error) throw error;
        
        if (!data) {
          toast({
            variant: "destructive",
            title: "Agent not found",
            description: "The agent you're trying to edit doesn't exist.",
          });
          navigate("/agents");
          return;
        }

        setAgent(data);
      } catch (error: any) {
        toast({
          variant: "destructive",
          title: "Failed to load agent",
          description: error.message || "An unexpected error occurred.",
        });
        navigate("/agents");
      } finally {
        setIsLoading(false);
      }
    };

    fetchAgent();
  }, [id, navigate]);

  if (isLoading) {
    return (
      <MainLayout>
        <div className="flex justify-center items-center min-h-[50vh]">
          <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent"></div>
        </div>
      </MainLayout>
    );
  }

  return (
    <MainLayout>
      <div className="container mx-auto py-8">
        <AgentForm agent={agent} isEditMode={true} hideSubmitButton={true} />
      </div>
    </MainLayout>
  );
};

export default AgentEdit;
